export default "__VITE_ASSET__9959c679__"